export const securityKey = {
  // MYWORKSPACE: "My Work Space",
  // DASHBOARD: "Dashboard",
  // CLIENTS: "Clients",
  // DEPARTMENTS: "Departments",
  // REPORTS: "Repairs",
  // SCOPES: "Scopes",
  // REPEIRITEMS: "Repair Items",
  // INVENTORY: "Inventory",
  // INVOICES: "Invoices",
  // ACQUISITIONS: "Acquisitions",
  // CARTS: "Carts",
  // CONTRACTS: "Contracts",
  // QUALITY: "Quality",
  // REPORTSEXTRACTS: "Reports/Extracts",
  // TOOLS: "Tools",
  // ADMINISTRATION: "Administration",



  COMMONPAGE: 'CommanPage',

  //Project Maangement
  PROJECTMANAGEMENT: 'ProjectManagement',
  PROJECTLIST: 'ProjectList',
  PROJECTDETAILS: 'ProjectDetails',
  PROJECTTEAM: 'ProjectTeam',
  PROJECTCONFIG: 'ProjectConfig',

  //Team Management
  TEAMMANAGEMENT: 'TeamManagement',
  TEAMDETAILS: 'TeamDetails',
  TEAMPLANNING: 'TeamPlanning',
  /// Dedicated Team Overview key — seed in role permissions before switching routes off COMMONPAGE.
  TEAMOVERVIEW: 'TeamOverview',
  REVIEWTIMESHEET: 'TimeSheetReview',

  //Admin
  ADMIN: 'Admin',

};
